import React, {useContext} from "react";
import "./HeaderMobile.css";
import SLogo from "../../../../assets/images/SLogo.png";
import AffinityInfoContext from "../../../../context/AffinityContext";
import {useHistory} from "react-router-dom";

const HeaderMobile = () => {
    const history = useHistory()
    const {
        affinityId,
        affinityInterCode
    } = useContext(AffinityInfoContext);
    return (
        <React.Fragment>
            <div
                className="superior-rectangle"
                style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    height: "70px",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                        justifyContent:"center",
                        alignItems:"center"
                    }}
                >
                    <img
                        className="s-logo-mobile"
                        src={SLogo}
                        alt="SLogo"
                        onClick={() => {
                            history.push({pathname: '/a/'+ affinityInterCode +'/' + affinityId + '/productos'})
                        }}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default HeaderMobile;
